import { ChatBotUIDateSlot } from "@jugl-web/domain-resources/chat-bot/types";
import { useTranslations } from "@jugl-web/utils";
import format from "date-fns/format";
import { FC } from "react";
import { ReactComponent as CalendarIcon } from "./assets/calendar.svg";

interface BookingAttemptedMessageProps {
  selectedSlot: ChatBotUIDateSlot;
}

export const BookingAttemptedMessage: FC<BookingAttemptedMessageProps> = ({
  selectedSlot,
}) => {
  const { t } = useTranslations();

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <CalendarIcon className="shrink-0" />
        <span className="font-secondary text-[15px] leading-[20px] font-medium text-dark">
          {t({
            id: "chat-bot-ui.date-slot-booking.booking-details",
            defaultMessage: "Booking details",
          })}
        </span>
      </div>
      <div>
        <span className="font-base font-secondary text-sm leading-[140%] text-dark-700">
          {t(
            {
              id: "chat-bot-ui.date-slot-booking.attempted-book",
              defaultMessage:
                "You attempted to book a slot on {date} at {time}",
            },
            {
              date: format(selectedSlot.startTime, "d MMMM, yyyy"),
              time: format(selectedSlot.startTime, "h:mm a"),
            }
          )}
        </span>
      </div>
    </div>
  );
};
